// 作成者のときのポリシー
export const createdByAttributePolicyDefinition: Record<'manage-policy', boolean | undefined> = {
  // 作成者のときは、権限設定ができる
  [`manage-policy`]: true,
}
